module.exports = __webpack_public_path__ + "img/placeholder-landscape.ddfecbcb.svg";